var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"header"},[(_vm.title)?_c('h1',{class:['title', 'is-'+_vm.size]},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("left")],2)]),_vm._v(" "),_c('div',{staticClass:"level-right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }